const DEFAULT_BASE_DOMAIN = "jewel-flow.com";

export function getBaseDomain() {
  return String(process.env.REACT_APP_PUBLIC_BASE_DOMAIN || process.env.REACT_APP_BASE_DOMAIN || DEFAULT_BASE_DOMAIN)
    .trim()
    .toLowerCase()
    .replace(/^\.+/, "")
    .replace(/\.+$/, "");
}

export function isLocalHostname(hostname) {
  const host = String(hostname || "").trim().toLowerCase();
  return host === "localhost" || host === "127.0.0.1";
}

export function extractTenant(hostname) {
  const host = String(hostname || "").trim().toLowerCase();
  if (!host || isLocalHostname(host)) return "";
  const baseDomain = getBaseDomain();
  const suffix = `.${baseDomain}`;
  if (!host.endsWith(suffix)) return "";
  const tenant = host.slice(0, -suffix.length);
  return tenant.replace(/[^a-z0-9-]/g, "").trim();
}

export function buildTenantHost(tenantId) {
  const tenant = String(tenantId || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
  if (!tenant) return "";
  return `${tenant}.${getBaseDomain()}`;
}
